import { render, staticRenderFns } from "./BreadcrumbCpn.vue?vue&type=template&id=4e836545&scoped=true"
import script from "./BreadcrumbCpn.vue?vue&type=script&lang=js"
export * from "./BreadcrumbCpn.vue?vue&type=script&lang=js"
import style0 from "./BreadcrumbCpn.vue?vue&type=style&index=0&id=4e836545&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e836545",
  null
  
)

export default component.exports